module.exports = __webpack_public_path__ + "img/10-3.46c12ac9.png";